<template>
  <OImage :src="profilePictureUrl" :alt="`${item.name} Profil Resmi`" :width="width" :height="height" loading="lazy" />
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OImage },
  props: {
    item: {
      type: Object,
      required: true,
    },
    width: {
      default: 140,
    },
    height: {
      default: 140,
    },
  },
  setup({ item, width, height }) {
    const profilePictureUrl = item.imageId
      ? getImageUrl({ _id: item.imageId, resolutions: { standard: { url: item.image } } }, { width: Number(width), height: Number(height) })
      : item.image;
    return { profilePictureUrl };
  },
});
</script>
